import React, { ReactElement, useCallback } from 'react'

// noinspection ES6PreferShortImport
import { useNotifyingState } from '../../extensions'
import { ConfirmationView } from './ConfirmationView'

export interface InputConfirmationFormProps<T> {
  initialValue?: T
  onSelect: (value: T | undefined) => void
  renderConfirmationLabel: (value: T) => ReactElement | null
  renderConfirmationDetails?: (value: T) => ReactElement
  renderSearch: (onSelect: (value: T) => void) => ReactElement
  lowerConfirmationContent?: ReactElement
}

export const SearchViewWithConfirmation = <T,>(
  props: InputConfirmationFormProps<T>,
): ReactElement => {
  const {
    initialValue,
    renderConfirmationLabel,
    renderConfirmationDetails,
    renderSearch,
    onSelect,
    lowerConfirmationContent,
  } = props

  const [value, setValue] = useNotifyingState(initialValue, [onSelect])

  const onChange = useCallback(() => setValue(undefined), [setValue])

  return value ? (
    <ConfirmationView
      onChange={onChange}
      label={renderConfirmationLabel(value)}
      details={renderConfirmationDetails?.(value)}
      lowerContent={lowerConfirmationContent}
    />
  ) : (
    renderSearch(setValue)
  )
}
